<!-- TEMPLATE -->
<template>
    <div :class='customerOverviewClass'>
        <div class='row'>
            <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
                <dean-section-title content='true'>
            <span slot='title'>
                <span class='avenir-heavy'>offerte aanmaken ⟶ selecteer een klant</span>
            </span>
                    <dean-section-title-item
                            :icon='plusIcon'
                            :content="true"
                            @click.native="sectionRoute('customers.add', {
                              partnerId: $route.params.partnerId,
                              createQuote: true,
                            })">
                        Klant Toevoegen
                    </dean-section-title-item>
                </dean-section-title>
                <div class="filter">
                    <dean-form-row
                        @input="update(true)"
                        v-model="pageMeta.query"
                        class="top-bar"
                        hide-label="true"
                    >zoek
                    </dean-form-row>

                    <button :class="{active: pageMeta.cloudService == true}" id="servicecloud">
                        <dean-icon
                            :glyph="deanCloudIcon"
                            @click.native="pageMeta.cloudService = !pageMeta.cloudService; update()"
                            width="20"
                            height="20"
                        ></dean-icon>
                    </button>
                    <b-tooltip target="servicecloud" placement="bottom">
                        Cloud
                    </b-tooltip>

                    <button :class="{active: pageMeta.connectionService == true}" id="serviceinternet">
                        <dean-icon :glyph="deanInternetIcon"
                                   @click.native="pageMeta.connectionService = !pageMeta.connectionService; update()"
                                   width="20"
                                   height="20"
                        ></dean-icon>
                    </button>
                    <b-tooltip target="serviceinternet" placement="bottom">
                        Connection
                    </b-tooltip>

                    <button :class="{active: pageMeta.mobileService == true}" id="servicemobile">
                        <dean-icon :glyph="deanMobileOdidoIcon"
                                   @click.native="pageMeta.mobileService = !pageMeta.mobileService; update()"
                                   width="20"
                                   height="20"
                        ></dean-icon>
                    </button>
                    <b-tooltip target="servicemobile" placement="bottom">
                        Odido Mobile
                    </b-tooltip>

                  <button :class="{active: pageMeta.mobileKpnService == true}" id="servicemobilekpn">
                    <dean-icon :glyph="deanMobileKpnIcon"
                               @click.native="pageMeta.mobileKpnService = !pageMeta.mobileKpnService; update()"
                               width="20"
                               height="20"
                    ></dean-icon>
                  </button>
                  <b-tooltip target="servicemobilekpn" placement="bottom">
                    KPN Mobile
                  </b-tooltip>

                    <button :class="{active: pageMeta.sipTrunkService == true}" id="servicesiptrunk">
                      <dean-icon :glyph="deanSipTrunkIcon"
                                @click.native="pageMeta.sipTrunkService = !pageMeta.sipTrunkService; update()"
                                width="20"
                                height="20"
                      ></dean-icon>
                    </button>
                    <b-tooltip target="servicesiptrunk" placement="bottom">
                      Sip Trunk
                    </b-tooltip>
                </div>
                <dean-table
                        :data='customerData'
                        :columns='columns'
                        :hover="true"
                        @column-click='columnClick'
                        @cell-click="cellClick"
                >
            <span slot="contractedServices" slot-scope="contractedServices">
              <dean-icon v-for="serviceIcon in contractedServices.value.content"
                         :key="serviceIcon.id"
                         className="serviceIcon"
                         :glyph="serviceIcon"
                         width="25"
                         height="25"
                         title="Service">
              </dean-icon>
            </span>
                </dean-table>
                <dean-pagination
                        :current-page='customerMetaData.pageNumber'
                        :total-items='customerMetaData.totalResults'
                        :items-per-page='customerMetaData.itemsPerPage'
                        :select-items-per-page='selectItemsPerPage'
                        :visible-pages='customerMetaData.visiblePages'
                        @page-changed='paginationChanged'
                        @items-per-page='itemsPerPageChanged'
                >
                </dean-pagination>
            </div>
        </div>
    </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';
  import {deanDialogBus} from '@/main';

  import {
    // SVG
    // SVG
    invoicesIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
    deanCloudIcon,
    deanInternetIcon,
    customIconPhoneCall,
    customIconSmartphoneOdido,
    customIconSmartphoneKpn,
    deanButton,
  } from '@deanone/dean-components';
  import axios from 'axios';
  import {servicesStringToIcons} from '@/mixins/stringToIcons';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {BTooltip} from 'bootstrap-vue';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
      deanButton,
      deanFormRow,
      BTooltip,
    },
  })
  export default class List extends mixins(deanTableMixin) {

    public customers: object[] = [];
    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public deanCloudIcon: object = deanCloudIcon;
    public deanInternetIcon: object = deanInternetIcon;
    public deanMobileOdidoIcon: object = customIconSmartphoneOdido;
    public deanMobileKpnIcon: object = customIconSmartphoneKpn;
    public deanSipTrunkIcon: object = customIconPhoneCall;
    public queryTimeout!: number;

    // COMPUTED
    get customerOverviewClass() {
      let value = 'customer-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get customerMetaData() {
      return this.pageMeta;
    }

    get customerData() {
      return this.customers;
    }

    // DATA
    public sideMenu: object = {
      content: {
        title: {
          text: 'Offertes',
          mobile: {
            close: {
              text: 'Close',
              icon: invoicesIcon,
            },
          },
        },
        type: 'themed',
        sections: {
          filters: {
            title: 'status',
            items: {
              summery: {
                title: 'Overzicht',
                icon: summeryIcon,
                name: 'quotes.overview',
              },
              active: {
                title: 'Gewonnen',
                icon: summeryIcon,
                name: 'quotes.overview.status',
                params: {status: 'won'},
              },
              blocked: {
                title: 'Verworpen',
                icon: summeryIcon,
                name: 'quotes.overview.status',
                params: {status: 'discarded'},
              },
              inactive: {
                title: 'Verloren',
                icon: summeryIcon,
                name: 'quotes.overview.status',
                params: {status: 'lost'},
              },
              archived: {
                title: 'Archief',
                icon: summeryIcon,
                name: 'quotes.overview.status',
                params: {status: 'deleted'},
              },
            },
          },
        },
      },
    };

    public columns: any = {
      code: {
        content: 'klant-nummer',
        align: 'left',
        sort: true,
        dql: 'code',
      },
      name: {
        content: 'name',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      pchsnr: {
        content: 'pchsnr',
        align: 'left',
        dql: 'pchsnr',
      },
      city: {
        content: 'plaats',
        align: 'left',
        dql: 'city',
      },
      monthValueOrders: {
        content: 'maandwaarde orders',
        align: 'left',
        dql: 'monthValueOrders',
      },
      contractedServices: {
        content: 'diensten',
        type: 'slot',
        slot: 'contractedServices',
        align: 'center',
        dql: 'contractedServices',
      },
    };

    public tableName(): string {
      return 'quotes-customers';
    }

    public update(timeout: boolean) {
      const self = this;
      const meta: any = self.pageMeta;

      if (timeout) {
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
        this.queryTimeout = setTimeout(() => {
          self.loadList(meta);
        }, 500);
      } else {
        this.loadList(meta);
      }
    }

    public cellClick(target: { cell: object, row: { id: string }, column: string }) {
      if (this.$store.getters.getUser.privileges.includes('view-partner') && !this.$route.params.partnerId) {
        this.getPartners(target.row.id);
      } else {
        this.getAgreements(target.row.id, this.$route.params.partnerId || this.$store.getters.getUser.organizationId);
      }
    }

    public getPartners(customerId: any) {
      this.$store.dispatch('setLoadOverlay', true);
      axios.post('/-/trade/api/customer.partner.list', {
        id: customerId,
      }).then(
        (response) => {
          const partners = response.data;
          switch (true) {
            case (partners.length === 0):
              this.$toast({
                title: 'Fout',
                text: 'Er kunnen momenteel geen partners voor deze klant gevonden worden, er kan helaas geen offerte aangemaakt worden.',
                theme: 'danger',
              });
              this.$store.dispatch('setLoadOverlay', false);
              break;
            case (partners.length === 1):
              this.getAgreements(customerId, partners[0].value);
              break;
            case (partners.length > 1):
              this.$store.dispatch('setLoadOverlay', false);
              this.openDialog(
                partners,
                'partner',
                (partnerId: string) => this.getAgreements(customerId, partnerId),
              );
              break;
          }
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public getAgreements(customerId: string, partnerId: string) {
      this.$store.dispatch('setLoadOverlay', true);
      axios.post('/-/trade/api/customer.partner.agreements.list', {
        id: partnerId,
        activeOnly: true,
      }).then(
        (response) => {
          const agreements = response.data.data;
          switch (true) {
            case (agreements.length === 0):
              this.$toast({
                title: 'Fout',
                text: 'De partner van deze klant heeft geen overeenkomsten, er kan geen offerte aangemaakt worden.',
                theme: 'danger',
              });
              this.$store.dispatch('setLoadOverlay', false);
              break;
            case (agreements.length === 1):
              this.createQuote(customerId, agreements[0].id);
              break;
            case (agreements.length > 1):
              this.$store.dispatch('setLoadOverlay', false);
              this.openDialog(agreements.map((agreement: { id: string, description: string, typeName: string }) => ({
                  value: agreement.id,
                  label: agreement.description + ' (' + agreement.typeName + ')',
                }),
              ), 'overeenkomst', (agreementId: string) => this.createQuote(customerId, agreementId));
              break;
            default:
              break;
          }
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const url = this.$route.params.partnerId || !this.$store.getters.getUser.privileges.includes('view-partner')
          ? 'partner.customers.list' : 'admin.customers.list';

      axios.post(`/-/trade/api/${url}`, {
        pid: this.$route.params.partnerId || this.$store.getters.getUser.organizationId,
        meta: {
          startIndex: this.startIndex,
          numberOfItems: data.itemsPerPage,
        },
        filter: data.query,
        sort: data.sort,
        cloudService: data.cloudService,
        internetService: data.connectionService,
        mobileService: data.mobileService,
        sipTrunkService: data.sipTrunkService,
      }).then(
        (response) => {
          this.customers = response.data.data.map((customer: any) => {
            return {
              id: customer.id,
              code: customer.code,
              name: customer.name,
              pchsnr: customer.adddress ? (customer.address.postalCode +
                  ' / ' +
                  customer.address.houseNumber + (
                      customer.address.houseNumberExtension ?
                          '-' + customer.address.houseNumberExtension :
                          ''
                  )
              ) : '-',
              city: customer.address ? customer.address.city : '-',
              monthValueOrders: new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR',
              }).format(customer.monthlyOrderValue),
              contractedServices: servicesStringToIcons(customer.services),
            };
          });
          this.updateMeta(response.data.meta);
          this.$store.dispatch('setLoadOverlay', false);
          this.$store.dispatch('updateSideMenu', this.sideMenu);
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      );
    }

    public created() {
      this.setDefaultSort('name');
      this.loadList(this.pageMeta);
    }

    public openDialog(options: any, title: string, callback: (arg: any) => void) {
      deanDialogBus.$emit('open', 'SelectOptionDialog', {
        options,
        title,
        callback,
      });
    }

    private createQuote(customerId: string, agreementId: string) {
      this.$store.dispatch('setLoadOverlay', true);
      axios.post('/-/trade/api/quote.create', {
        customerId,
        paid: agreementId,
      }).then(
        (response) => {
          this.$toast({
            text: 'Offerte toegevoegd.',
            theme: 'success',
            icon: plusIcon,
          });

          this.$router.push({
            name: 'quotes.edit',
            params: {
              id: response.data,
            },
          });
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(
        () => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';

    .filter {
        display: flex;
    }

    button {
        fill: var(--color-dark, $color-dark);
        background: none;
        padding: 5px;
        border: 0;
        margin: 5px;
        transition: fill .3s;
        border-radius: 5px;
    }

    button.active,
    button:hover {
        fill: var(--color-secondary, $color-secondary);
    }

    .top-bar {
        display: inline-block;
    }

    :deep(.top-bar .hd-6.columns) {
      width: 100%;
    }
</style>